import React from 'react';
import PropTypes from 'prop-types';
import FusionCheckbox from '@acuity-brands/fusion/components/Checkbox';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion Checkbox component, use it directly.
 */
export const FusionCheckboxAdapter = ({
  data,
  disabled,
  field,
  handleChange,
  name,
}) => (
  <FusionCheckbox
    checked={data || false}
    disabled={disabled}
    label={field.label}
    name={name}
    onChange={handleChange}
  />
);

FusionCheckboxAdapter.propTypes = {
  data: PropTypes.any,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};
